'use client';

import React, { useRef, useEffect } from 'react';

import styles from './styles.module.scss';

const FunkyLogo = props => {
  const ref = useRef(null);
  const timeoutRef = useRef(null);

  function onMouseEnter() {
    if (props.isSafari) return;

    timeoutRef.current = setTimeout(() => {
      if (ref.current) {
        ref.current.play();
        ref.current.loop = true;
      }
    }, 150);
  }

  function onMouseLeave() {
    if (props.isSafari) return;

    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    if (ref.current) {
      ref.current.loop = false;
    }
  }

  function onEnded() {
    if (ref.current) {
      ref.current.currentTime = 0;
    }
  }

  useEffect(() => {
    if (!props.isSafari) {
      setTimeout(() => {
        if (ref.current) {
          ref.current.play();
        }
      }, 1000);
    }
  }, []);

  return (
    <>
      <div onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave} className={styles.funkyLogo}>
        {props.isSafari ? (
          <img
            src="https://cdn.welovealfa.com/alfa-logo-white.png"
            style={{ width: 60 }}
            alt="Logo"
          />
        ) : (
          <video ref={ref} muted playsInline onEnded={onEnded}>
            <source src="https://cdn.welovealfa.com/wink-short.webm" type="video/webm" />
          </video>
        )}
      </div>
    </>
  );
};

export default FunkyLogo;
